import { Controller } from "@hotwired/stimulus"

// 数値入力にカンマを自動で入れて読みやすくする。type="text" inputmode="numeric" の欄に付ける。
// 表示上はカンマ区切り、送信直前にカンマを外して素の整数をサーバへ渡す。
// ↑↓キーで step 単位 (既定 10 万) の増減ができ、ネイティブ数値欄のスピナー相当の操作感にする。
//
// 使い方 (admin のフォームは Admin::ApplicationHelper#comma_number_input_html を使う):
//   <%= form.input :amount, input_html: comma_number_input_html(step: 1_000_000) %>
//
//   <input type="text" inputmode="numeric"
//     data-controller="comma-number"
//     data-action="input->comma-number#format keydown->comma-number#step"
//     data-comma-number-step-value="100000">
export default class extends Controller {
  static values = {
    step: { type: Number, default: 100000 },
    min: { type: Number, default: 0 },
  }

  connect() {
    this.format()
    this.stripOnSubmit = this.strip.bind(this)
    this.element.form?.addEventListener("submit", this.stripOnSubmit)
  }

  disconnect() {
    this.element.form?.removeEventListener("submit", this.stripOnSubmit)
  }

  // 入力のたびに数字だけ取り出してカンマ整形する
  format() {
    const digits = this.digits()
    this.element.value = digits === "" ? "" : Number(digits).toLocaleString("en-US")
  }

  // 送信直前にカンマを外して素の整数にする (サーバ側の integer キャストがカンマで壊れないように)
  strip() {
    this.element.value = this.digits()
  }

  // ↑↓キーで step 単位に増減する
  step(event) {
    if (event.key !== "ArrowUp" && event.key !== "ArrowDown") return

    event.preventDefault()
    const current = Number(this.digits() || "0")
    const delta = event.key === "ArrowUp" ? this.stepValue : -this.stepValue
    const next = Math.max(this.minValue, current + delta)
    this.element.value = next.toLocaleString("en-US")
  }

  // 入力値から数字だけを取り出す
  digits() {
    return this.element.value.replace(/\D/g, "")
  }
}
